// import { Fragment, useEffect, useState } from "react";
// import { Card, CardActionArea, CardContent, Typography, Grid } from "@mui/material";
// import { APIRouteConstants } from "constants/routeConstants";
// import axiosInstance from "configs/axiosConfig";
// import LocalShippingIcon from '@mui/icons-material/LocalShipping';
// import LocalMallIcon from '@mui/icons-material/LocalMall';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle'; // Add the CheckCircleIcon import
// import { customeStyle } from "utils/style";
// import { ENABLED_D6_FEATURE } from "constants/appConstants";
// import { useSelector } from "react-redux";

// const ShippingOptionCard = ({ selected, onSelcted, paymentModess, selectAddress  }) => {
//     const handleSelect = (option) => {
//         selectAddress();
//         onSelcted(option);
//     };

//     const webDetails = useSelector(state => state.webDetails);
//     const { websiteInfo } = webDetails;
//     const hasPickUpAtStore = websiteInfo?.delivery_option?.includes("store_pickup")
//     const hasRoomDeliver = websiteInfo?.delivery_option?.includes("room_deliver")
//     const hasShippingAtStore = websiteInfo?.delivery_option?.includes("shipping")
    
//     const IS_mclardies_APP = "localhost:3000" === window?.location?.host || "mclardies.webbieshop.com" === window?.location?.host
//     // const IS_mclardies_APP = ENABLED_D6_FEATURE.includes(window?.location?.host)
 
//     return (
//         <Fragment>
//             <Grid item pb={2}>
//                 <Typography fontSize={customeStyle.typography.subhading} gutterBottom>
//                     Please select a delivery method:
//                 </Typography>
//             </Grid>
//             <Grid container spacing={2}>
//                 {(hasShippingAtStore&&!IS_mclardies_APP) &&
//                     <Grid item xs={12} sm={6} md={4} lg={5}>
//                         <Card
//                             sx={{
//                                 overflow:"visible",
//                                 borderRadius: "0.5rem",
//                                 border: selected === "shipping" ? "1px solid #1976d2" : "1px solid #ccc",
//                                 position: "relative" // This allows for absolute positioning of the icon
//                             }}
//                         >
//                             {selected === "shipping" && (
//                                 <CheckCircleIcon
//                                     sx={{
//                                         position: "absolute",
//                                         top: -5,
//                                         right: -5,
//                                         color: "#1976d2",
//                                         fontSize: 20,
//                                         backgroundColor: "#fff",
//                                         borderRadius: "50%",
//                                         zIndex: 99
//                                     }}
//                                 />
//                             )}
//                             <CardActionArea onClick={() => handleSelect("shipping")}>
//                                 <CardContent sx={{
//                                     p: 1,
//                                     display: "flex",
//                                     alignItems: "center",
//                                     justifyContent: "center",
//                                     gap: "0.2rem"
//                                 }}>
//                                     <LocalShippingIcon sx={{ fontSize: "0.9rem",color:selected === "shipping" ? " #1976d2" : "#000", }} />
//                                     <Typography fontSize={customeStyle.buttomfont} sx={{color:selected === "shipping" ? " #1976d2" : "#000",}} align="center">Shipping</Typography>
//                                 </CardContent>
//                             </CardActionArea>
//                         </Card>
//                     </Grid>
//                 }
//                 {/* Pickup Option */}
//                 {hasPickUpAtStore &&
//                     <Grid item xs={12} sm={6} md={4} lg={5} >
//                         <Card
//                             sx={{
//                                 overflow:"visible",
//                                 borderRadius: "0.5rem",
//                                 border: selected === "store_pickup" ? "1px solid #1976d2" : "1px solid #ccc",
//                                 position: "relative" // This allows for absolute positioning of the icon
//                             }}
//                         >
//                             {selected === "store_pickup" && (
//                                 <CheckCircleIcon
//                                     sx={{
//                                         position: "absolute",
//                                         top: -5,
//                                         right: -5,
//                                         color: "#1976d2",
//                                         fontSize: 20,
//                                         backgroundColor: "#fff",
//                                         borderRadius: "50%",
//                                         zIndex: 99
//                                     }}
//                                 />
//                             )}
//                             <CardActionArea onClick={() => handleSelect("store_pickup")}>
//                                 <CardContent sx={{
//                                     p: 1,
//                                     display: "flex",
//                                     alignItems: "center",
//                                     justifyContent: "center",
//                                     gap: "0.2rem"
//                                 }}>
//                                     <LocalMallIcon sx={{ fontSize: "1rem",color:selected === "store_pickup" ? " #1976d2" : "#000", }} />
//                                     <Typography fontSize={customeStyle.buttomfont} sx={{color:selected === "store_pickup" ? " #1976d2" : "#000",}} align="center">Pickup at Store</Typography>
//                                 </CardContent>
//                             </CardActionArea>
//                         </Card>
//                     </Grid>
//                 }
//                 {hasRoomDeliver &&
//                     <Grid item xs={12} sm={6} md={4} lg={5} >
//                         <Card
//                             sx={{
//                                 overflow:"visible",
//                                 borderRadius: "0.5rem",
//                                 border: selected === "room_deliver" ? "1px solid #1976d2" : "1px solid #ccc",
//                                 position: "relative" // This allows for absolute positioning of the icon
//                             }}
//                         >
//                             {selected === "room_deliver" && (
//                                 <CheckCircleIcon
//                                     sx={{
//                                         position: "absolute",
//                                         top: -5,
//                                         right: -5,
//                                         color: "#1976d2",
//                                         fontSize: 20,
//                                         backgroundColor: "#fff",
//                                         borderRadius: "50%",
//                                         zIndex: 99
//                                     }}
//                                 />
//                             )}
//                             <CardActionArea onClick={() => handleSelect("room_deliver")}>
//                                 <CardContent sx={{
//                                     p: 1,
//                                     display: "flex",
//                                     alignItems: "center",
//                                     justifyContent: "center",
//                                     gap: "0.2rem"
//                                 }}>
//                                     <LocalMallIcon sx={{ fontSize: "1rem",color:selected === "room_deliver" ? " #1976d2" : "#000", }} />
//                                     <Typography fontSize={customeStyle.buttomfont} sx={{color:selected === "room_deliver" ? " #1976d2" : "#000",}} align="center">Deliver to Room</Typography>
//                                 </CardContent>
//                             </CardActionArea>
//                         </Card>
//                     </Grid>
//                 }
//                 {(!hasPickUpAtStore && !hasShippingAtStore && !hasRoomDeliver) &&
//                     <Grid item pt={2}>
//                         <Typography color={"error"} fontSize={customeStyle.typography.subhading1}>No Payment mode available at the moment</Typography>
//                     </Grid>
//                 }
//             </Grid>
//         </Fragment>
//     );
// };

// export default ShippingOptionCard;


























import React, { Fragment } from "react";
import {
  Card,
  CardActionArea,
  CardContent,
  Typography,
  Grid,
} from "@mui/material";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import LocalMallIcon from "@mui/icons-material/LocalMall";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { customeStyle } from "utils/style";
import { useSelector } from "react-redux";

const optionIcons = {
  shipping: <LocalShippingIcon sx={{ fontSize: "0.9rem" }} />,
  store_pickup: <LocalMallIcon sx={{ fontSize: "1rem" }} />,
  room_deliver: <LocalMallIcon sx={{ fontSize: "1rem" }} />,
};

const optionLabels = {
  shipping: "Shipping",
  store_pickup: "Pickup at Store",
  room_deliver: "Deliver to Room",
};

const ShippingOptionCard = ({ selected, onSelcted, selectAddress }) => {
  const handleSelect = (option) => {
    selectAddress();
    onSelcted(option);
  };

  const websiteInfo = useSelector(state => state.webDetails.websiteInfo);
  const deliveryOptions = websiteInfo?.delivery_option || [];

  return (
    <Fragment>
      <Grid item pb={2}>
        <Typography fontSize={customeStyle.typography.subhading} gutterBottom>
          Please select a delivery method:
        </Typography>
      </Grid>
      <Grid container spacing={2}>
        {deliveryOptions.length > 0 ? (
          deliveryOptions.map((option) => (
            <Grid key={option} item xs={12} sm={6} md={4} lg={5}>
              <Card
                sx={{
                  overflow: "visible",
                  borderRadius: "0.5rem",
                  border: selected === option ? "1px solid #1976d2" : "1px solid #ccc",
                  position: "relative",
                }}
              >
                {selected === option && (
                  <CheckCircleIcon
                    sx={{
                      position: "absolute",
                      top: -5,
                      right: -5,
                      color: "#1976d2",
                      fontSize: 20,
                      backgroundColor: "#fff",
                      borderRadius: "50%",
                      zIndex: 99,
                    }}
                  />
                )}
                <CardActionArea onClick={() => handleSelect(option)}>
                  <CardContent
                    sx={{
                      p: 1,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "0.2rem",
                    }}
                  >
                    {optionIcons[option] &&
                      React.cloneElement(optionIcons[option], {
                        color: selected === option ? "#1976d2" : "#000",
                      })}
                    <Typography
                      fontSize={customeStyle.buttomfont}
                      sx={{
                        color: selected === option ? "#1976d2" : "#000",
                      }}
                      align="center"
                    >
                      {optionLabels[option] || option}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))
        ) : (
          <Grid item pt={2}>
            <Typography color={"error"} fontSize={customeStyle.typography.subhading1}>
              No delivery options available at the moment
            </Typography>
          </Grid>
        )}
      </Grid>
    </Fragment>
  );
};

export default ShippingOptionCard;
